// src/modules/purityAnalyzer/components/MetricCard.jsx
// Small laboratory-style metric card with mount micro-interaction.

import React from 'react';
import { Card, Typography, theme } from 'antd';
import { motion } from 'framer-motion';

const { Text } = Typography;

export default function MetricCard({
  icon, title, value, suffix, precision, hint, color, delay = 0, size = 'default',
}) {
  const { token } = theme.useToken();
  const display =
    typeof value === 'number' && Number.isFinite(value)
      ? value.toLocaleString('en-IN', {
          maximumFractionDigits: precision ?? 3,
          minimumFractionDigits: 0,
        })
      : (value ?? '—');

  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay, ease: 'easeOut' }}
      style={{ height: '100%' }}
    >
      <Card size="small" style={{ height: '100%' }} styles={{ body: { padding: '10px 14px' } }}>
        <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
          {icon && (
            <span style={{ color: color || token.colorPrimary, marginRight: 6 }}>{icon}</span>
          )}
          {title}
        </Text>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginTop: 2 }}>
          <span
            style={{
              fontSize: size === 'large' ? 26 : 20,
              fontWeight: 650,
              fontVariantNumeric: 'tabular-nums',
              color: color || token.colorText,
            }}
          >
            {display}
          </span>
          {suffix && <Text type="secondary" style={{ fontSize: 12 }}>{suffix}</Text>}
        </div>
        {hint && (
          <Text type="secondary" style={{ fontSize: 11, display: 'block', marginTop: 2 }}>
            {hint}
          </Text>
        )}
      </Card>
    </motion.div>
  );
}
